// extracted by mini-css-extract-plugin
module.exports = {"categories":"styles_categories__4jeci","top":"styles_top__2qDRi","active":"styles_active__OQg_6"};